
import { Component, Mixins } from "vue-property-decorator";
import SideMenuLayout from "@/views/sidebar/side-menu-layout.vue";
import SurveyMixin from "@/views/sidebar/survey/survey.mixin";
import { SurveyResult } from "@/views/sidebar/survey/survey.types";
import CardComponent from "@/components/card.vue";
import moment from "moment";

@Component({
  components: {
    CardComponent,
    "side-menu-layout": SideMenuLayout
  }
})
export default class SurveyQuestionsComponent extends Mixins(SurveyMixin) {
  showSurveys = true;
  showAssessments = true;
  loading = false;

  get groupedByMonth() {
    const grouped: { [key: string]: any[] } = {};
    const filteredAnswers = this.surveyAnswers.filter((answer: SurveyResult) => {
      if (answer.type === 'Survey' && this.showSurveys) return true;
      if (answer.type.endsWith('Assessment') && this.showAssessments) return true;
      return false;
    });

    filteredAnswers.forEach((answer: any) => {
      const month = moment(answer.responseDate).format("MMMM YYYY");
      if (!grouped[month]) {
        grouped[month] = [];
      }
      grouped[month].push(answer);
    });

    return Object.entries(grouped)
      .map(([month, cards]) => ({ month, cards }))
      .sort((a, b) =>
        moment(b.month, "MMMM YYYY").valueOf() - moment(a.month, "MMMM YYYY").valueOf()
      );
  }

  async mounted() {
    this.loading = true;
    await this.fetchData();
    this.loading = false;
  }

  async fetchData() {
    const fetch = [
      this.$store.dispatch("Survey/fetchSurveyAnswers", {
        participantId: this.selectedPatientSummary.participantId, 
        clientId: this.selectedClientDDL.value,
        timezone: this.selectedClient.timezone
      }),
      this.$store.dispatch("Survey/fetchPhq9ChartOptions", this.selectedClientDDL.value),
      this.$store.dispatch("Survey/fetchGad7ChartOptions", this.selectedClientDDL.value),
      this.$store.dispatch("Survey/fetchSowsChartOptions", this.selectedClientDDL.value),
      this.$store.dispatch("Survey/fetchBamChartOptions", this.selectedClientDDL.value),
    ];
    await Promise.all(fetch);
  }

  toggleType(type: string) {
    if (type === 'Survey') {
      this.showSurveys = !this.showSurveys;
    } else if (type === 'Assessment') {
      this.showAssessments = !this.showAssessments;
    }
  }

  getIconClass(type: string) {
    return type === 'Survey'
      ? 'fa-solid fa-circle-question'
      : 'fa-solid fa-brain';
  }

  responseDate(date: string) {
    if (!date || date.trim() === "") {
      return "";
    }
    return moment(date).format("MM/DD/YYYY hh:mm A");
  }
}
